module.exports = __webpack_public_path__ + "img/ios.7130f3f1.png";